import { toast } from "react-toastify";
import { getTerminalError } from "@monorepo/helpers";
import { IResponseError, IService } from "@monorepo/types";

export const handleUpdateConflictingServiceUpdateError = ({
  err,
  service,
  setShowErrorModal,
  setInputErrors,
}: {
  err: Array<IResponseError>;
  service: IService;
  setShowErrorModal: React.Dispatch<React.SetStateAction<boolean>>;
  setInputErrors: React.Dispatch<React.SetStateAction<Array<IResponseError> | undefined>>;
}) => {
  const terminalError = getTerminalError(err);
  if (!!terminalError) {
    toast.error(terminalError);
  } else {
    err.forEach(({ source, title }) => {
      if (!source?.parameter) {
        toast.error(title, {
          toastId: service.id,
        });
      }
    });
  }
  setInputErrors(err.filter(({ source }) => source?.parameter));
  setShowErrorModal(false);
};
